<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M14.7222 2.22222H5.27772C3.59217 2.22222 2.22217 3.58889 2.22217 5.27778V14.7222C2.22217 16.4111 3.59217 17.7778 5.27772 17.7778H14.7222C16.4077 17.7778 17.7777 16.4111 17.7777 14.7222V5.27778C17.7777 3.58889 16.4077 2.22222 14.7222 2.22222ZM10.8333 13.8889C10.8333 14.349 10.4601 14.7222 9.99995 14.7222C9.53983 14.7222 9.16661 14.349 9.16661 13.8889V10.5556H8.61106C8.15095 10.5556 7.77772 10.1823 7.77772 9.72222C7.77772 9.26211 8.15095 8.88889 8.61106 8.88889H9.44439C10.2105 8.88889 10.8333 9.51167 10.8333 10.2778V13.8889ZM9.99995 7.5C9.38661 7.5 8.88883 7.00089 8.88883 6.38889C8.88883 5.77689 9.38661 5.27778 9.99995 5.27778C10.6133 5.27778 11.1111 5.77689 11.1111 6.38889C11.1111 7.00089 10.6133 7.5 9.99995 7.5Z"
            fill="#007AFF"
        />
    </svg>
</template>
